import { useCallback } from "react";
import { useLocale, useSetLocale } from "next-intl";

export function LocaleToggle() {
  const locale = useLocale();
  const setLocale = useSetLocale();
  const isEn = locale === "en";

  const toggle = useCallback(() => {
    setLocale(isEn ? "zh-CN" : "en");
  }, [isEn, setLocale]);

  return (
    <button
      className="text-muted-foreground hover:text-foreground hover:bg-surface-raised flex min-h-10 min-w-10 cursor-pointer items-center justify-center rounded px-3 py-2 text-base transition-all"
      onClick={toggle}
    >
      {isEn ? "文" : "EN"}
    </button>
  );
}
